import LanguageIcon from "@mui/icons-material/Language";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export const sidebarData = [
  {
    categoryName_chr: "Global News",
    icon: "global",
  },
  {
    categoryName_chr: "Periodicals & Speciality",
    icon: "periodicals",
  },
  {
    categoryName_chr: "Think Tanks",
    icon: "tanks",
  },
  {
    categoryName_chr: "Academia",
    icon: "academia",
  },
  {
    categoryName_chr: "Other Sources",
    icon: "other",
  },
  {
    categoryName_chr: "US Government",
    icon: "us",
  },
  {
    categoryName_chr: "Intergovernmental",
    icon: "inter",
  },
  {
    categoryName_chr: "UGC",
    icon: "ugc",
  },
];

export const sidebarIcons = {
  "Global News": <LanguageIcon />,
  "Periodicals & Speciality News": <WorkOutlineOutlinedIcon />,
  "Think Tanks": <LightbulbOutlinedIcon />,
  Academia: <SchoolOutlinedIcon />,
  "Other Selected Sources": <ExtensionOutlinedIcon />,
  "US Government": <AccountBalanceOutlinedIcon />,
  "Intergovernmental Organizations": <ViewInArOutlinedIcon />,
  "User Generated Content": <WarningAmberRoundedIcon />,
};
